import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaArrowLeft } from 'react-icons/fa';
import '../style-new.css';

const GroupChatList = () => {
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await fetch('/api/groups/my', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        });

        const data = await res.json();
        if (res.ok && data.success) {
          console.log('Fetched groups:', data.groups);
          setGroups(data.groups);
        } else {
          console.error('Failed to load groups:', data.message || 'Unknown error');
        }
      } catch (err) {
        console.error('Error fetching groups:', err);
      }
    };

    fetchGroups();
  }, []);

  return (
    <div className="page-container">
      <div className="button-group">
        <button
          onClick={() => navigate('/')}
          className="btn btn-primary"
        >
          <FaHome />
          Home
        </button>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-primary"
        >
          <FaArrowLeft />
          Back
        </button>
      </div>

      <div className="center-content">
        <h2>Your Groups</h2>
        {groups.length === 0 ? (
          <p>You are not a member of any groups.</p>
        ) : (
          <ul className="list-container">
            {groups.map((group) => (
              <li
                key={group.id}
                className="list-item"
                onClick={() => navigate(`/chat/group/${group.id}`)}
              >
                {group.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default GroupChatList;
